//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/DebugUI.js";
let d=[[],[],[["AdmUITemplates","AdmUITemplateTestManager",0],["ArchUITemplates","ArchUITemplateTestManager",0],["AssemUITemplates","AssemUITemplateTestManager",0],["CaeUITemplates","CaeUITemplateTestManager",0],["CamUITemplates","CamUITemplateTestManager",0],["DraftUITemplates","DraftUITemplateTestManager",0],["FfmUITemplates","FfmUITemplateTestManager",0],["KdaUITemplates","KdaUITemplateTestManager",0],["ModlUITemplates","ModlUITemplateTestManager",0],["NxsmUITemplates","NxsmUITemplateTestManager",0],["PerfUITemplates","PerfUITemplateTestManager",0],["PsasmUITemplates","PsasmUITemplateTestManager",0],["PsaUITemplates","PsaUITemplateTestManager",0],["RoutUITemplates","RoutUITemplateTestManager",0],["TcinUITemplates","TcinUITemplateTestManager",0],["LineDesignerUITemplates","LineDesignerUITemplateTestManager",0],["CmmInspectUITemplates","CmmInspectUITemplateTestManager",0],["ToolDesignerUITemplates","ToolDesignerUITemplateTestManager",0],["ALPUITemplates","ALPUITemplateTestManager",0]]];
SPLM.UITemplateTestManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.UITemplateTestManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;